import { produce } from "immer";
import {
  SEARCH_RESIDENT_GROUP,
  SEARCH_RESIDENT_GROUP_SUCCESS,
  SEARCH_RESIDENT_GROUP_FAILURE,
  FETCH_RESIDENT_GROUP,
  FETCH_RESIDENT_GROUP_SUCCESS,
  FETCH_RESIDENT_GROUP_FAILURE,
  ADD_RESIDENT_GROUP,
  ADD_RESIDENT_GROUP_SUCCESS,
  ADD_RESIDENT_GROUP_FAILURE,
  FETCH_RESIDENT_GROUP_ITEM,
  FETCH_RESIDENT_GROUP_ITEM_SUCCESS,
  FETCH_RESIDENT_GROUP_ITEM_FAILURE,
  EDIT_RESIDENT_GROUP,
  EDIT_RESIDENT_GROUP_SUCCESS,
  EDIT_RESIDENT_GROUP_FAILURE,
  DELETE_RESIDENT_GROUP,
  DELETE_RESIDENT_GROUP_SUCCESS,
  DELETE_RESIDENT_GROUP_FAILURE,
  SET_RESIDENT_GROUP_ADD_EDIT_MODAL,
} from "./constants";

export const initialState = {
  residentGroup: [],
  residentGroupSearchList: [],
  currentResidentGroup: null,
  residentGroupTotal: 0,
  isFetchingResidentGroup: false,
  isSearchingResidentGroup: false,
  isSubmittingResidentGroup: false,
  isDeletingResidentGroup: false,
  residentGroupAddEditModal: { open: false, isEditing: false, member: null },
};

const ResidentGroupReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SEARCH_RESIDENT_GROUP:
        draft.isSearchingResidentGroup = true;
        draft.residentGroupSearchList = [];
        break;
      case SEARCH_RESIDENT_GROUP_SUCCESS:
        draft.isSearchingResidentGroup = false;
        draft.residentGroupSearchList = Array.isArray(action.payload)
          ? action.payload
          : [];
        break;
      case SEARCH_RESIDENT_GROUP_FAILURE:
        draft.isSearchingResidentGroup = false;
        draft.residentGroupSearchList = [];
        break;

      case FETCH_RESIDENT_GROUP: {
        draft.isFetchingResidentGroup = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.residentGroup = [];
        }
        break;
      }
      case FETCH_RESIDENT_GROUP_SUCCESS: {
        draft.isFetchingResidentGroup = false;
        const payload = action.payload;
        const currentPage = payload?.current_page ?? 1;
        if (currentPage === 1) {
          draft.residentGroup = payload;
        } else {
          const prevData = Array.isArray(draft.residentGroup?.data)
            ? draft.residentGroup.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.residentGroup = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: currentPage,
          };
        }
        draft.residentGroupTotal =
          payload?.total ?? draft.residentGroupTotal ?? 0;
        break;
      }
      case FETCH_RESIDENT_GROUP_FAILURE:
        draft.isFetchingResidentGroup = false;
        draft.residentGroup = [];
        break;

      case ADD_RESIDENT_GROUP:
        draft.isSubmittingResidentGroup = true;
        break;
      case ADD_RESIDENT_GROUP_SUCCESS:
        draft.isSubmittingResidentGroup = false;
        break;
      case ADD_RESIDENT_GROUP_FAILURE:
        draft.isSubmittingResidentGroup = false;
        break;

      case FETCH_RESIDENT_GROUP_ITEM:
        draft.isFetchingResidentGroup = true;
        draft.currentResidentGroup = null;
        break;
      case FETCH_RESIDENT_GROUP_ITEM_SUCCESS:
        draft.isFetchingResidentGroup = false;
        draft.currentResidentGroup = action.payload;
        break;
      case FETCH_RESIDENT_GROUP_ITEM_FAILURE:
        draft.isFetchingResidentGroup = false;
        draft.currentResidentGroup = null;
        break;

      case EDIT_RESIDENT_GROUP:
        draft.isSubmittingResidentGroup = true;
        break;
      case EDIT_RESIDENT_GROUP_SUCCESS:
        draft.isSubmittingResidentGroup = false;
        break;
      case EDIT_RESIDENT_GROUP_FAILURE:
        draft.isSubmittingResidentGroup = false;
        break;

      case DELETE_RESIDENT_GROUP:
        draft.isDeletingResidentGroup = true;
        break;
      case DELETE_RESIDENT_GROUP_SUCCESS:
        draft.isDeletingResidentGroup = false;
        break;
      case DELETE_RESIDENT_GROUP_FAILURE:
        draft.isDeletingResidentGroup = false;
        break;

      case SET_RESIDENT_GROUP_ADD_EDIT_MODAL:
        draft.residentGroupAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          member: action.payload?.member ?? null,
        };
        break;

      default:
        break;
    }
  });

export default ResidentGroupReducer;
